import {
  BedDouble,
  CalendarDays,
  FileText,
  Landmark,
  Package,
  Receipt,
  ShoppingCart,
  Smartphone,
  Stethoscope,
  Syringe,
  UserCog,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface AuditModuleStyle {
  icon: LucideIcon;
  /** Tinted icon chip: background + foreground, light and dark. */
  chip: string;
}

const FALLBACK: AuditModuleStyle = {
  icon: FileText,
  chip: 'bg-muted text-muted-foreground',
};

const STYLES: Record<string, AuditModuleStyle> = {
  sales: { icon: ShoppingCart, chip: 'bg-blue-500/15 text-blue-700 dark:text-blue-300' },
  cash: { icon: Wallet, chip: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300' },
  open_accounts: { icon: Landmark, chip: 'bg-amber-500/15 text-amber-700 dark:text-amber-300' },
  invoicing: { icon: Receipt, chip: 'bg-violet-500/15 text-violet-700 dark:text-violet-300' },
  inventory: { icon: Package, chip: 'bg-orange-500/15 text-orange-700 dark:text-orange-300' },
  customers: { icon: Users, chip: 'bg-sky-500/15 text-sky-700 dark:text-sky-300' },
  users: { icon: UserCog, chip: 'bg-slate-500/15 text-slate-700 dark:text-slate-300' },
  customer_portal: { icon: Smartphone, chip: 'bg-pink-500/15 text-pink-700 dark:text-pink-300' },
  appointments: { icon: CalendarDays, chip: 'bg-teal-500/15 text-teal-700 dark:text-teal-300' },
  hospitalization: { icon: BedDouble, chip: 'bg-rose-500/15 text-rose-700 dark:text-rose-300' },
  vaccination_card: { icon: Syringe, chip: 'bg-lime-500/15 text-lime-700 dark:text-lime-300' },
  clinical: { icon: Stethoscope, chip: 'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300' },
};

export function auditModuleStyle(module: string): AuditModuleStyle {
  return STYLES[module] ?? FALLBACK;
}
